import React, { Component } from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

// // Shared layouts
import { Dashboard as DashboardLayout } from "layouts";
import { SearchInput, EditIntent } from "components";
import { IntentsList } from "./components";
import { Grid } from "@material-ui/core";
import { fetchIntents } from "../../redux/actions/intentsActions";

// Component styles
import styles from "./styles";

class Intents extends Component {
  signal = true;

  state = {
    isLoading: false,
    error: null,
    search: "",
    data: {},
    loaded: false,
    editOpen: false,
    editIntent: {}
  };

  async getIntents() {
    try {
      this.setState({ isLoading: true });
      await this.props.fetchIntents();
      this.setState({ isLoading: false, loaded: true });
    } catch (error) {
      if (this.signal) {
        this.setState({
          isLoading: false,
          loaded: true,
          error
        });
      }
    }
  }

  componentWillMount() {
    if (_.isEmpty(this.props.skill)) return;

    this.signal = true;
    this.getIntents();
  }

  componentWillReceiveProps(newProps, oldProps) {
    if (!_.isEmpty(newProps.skill) && !this.state.loaded && !this.state.isLoading) {
      this.getIntents();
    }
    this.setState({ intents: newProps.intents });
  }

  filterIntents = (event, val) => {
    this.setState({ search: event.target.value });
    let intentsList = { ...this.state.intents };
    _.forEach(intentsList, intents => {
      _.forEach(intents, intent => {
        intent.visible = _.includes(intent.connectionName.toLowerCase(), event.target.value.toLowerCase());
      });
    });
    this.setState({ intents: intentsList });
  };

  onCloseEdit = refreshData => {
    this.setState({ editOpen: false });
    if (refreshData) {
      this.getIntents();
    }
  };

  onOpenEdit = intent => {
    this.setState({ editOpen: true, editIntent: intent });
  };

  render() {
    const { classes } = this.props;

    const enabled = !_.isEmpty(this.state.intents) ? this.state.intents.skillIntents : [];
    const all = !_.isEmpty(this.state.intents) ? this.state.intents.templates : [];

    return (
      <DashboardLayout title="Intents" isLoading={this.state.isLoading || _.isEmpty(this.props.skill)}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <SearchInput
              value={this.state.search}
              className={classes.searchInput}
              onChange={this.filterIntents}
              placeholder="Search Intents"
            />
            <div className={classes.content}>
              <div className={classes.listClass}>
                <IntentsList
                  intents={all}
                  isLoading={this.state.isLoading}
                  name={"All Available Intents"}
                  onIntentClick={this.onOpenEdit}
                />
              </div>
            </div>
          </Grid>
          <Grid item lg={4} md={8} xl={3} xs={12} className={classes.enabledIntents}>
            <div>
              <div />
            </div>
          </Grid>
        </Grid>
        <EditIntent
          open={this.state.editOpen}
          intent={this.state.editIntent}
          showCreateButton={true}
          onClose={this.onCloseEdit}
        />
      </DashboardLayout>
    );
  }
}

Intents.propTypes = {
  classes: PropTypes.object.isRequired,
  fetchIntents: PropTypes.func
};

function mapStateToProps(state) {
  return {
    cognitoUser: state.auth.cognitoUser,
    intents: state.intents ? state.intents : {},
    skill: state.skill
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        fetchIntents
      },
      dispatch
    ),
    dispatch
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(Intents))
);
